const clampNumber = (value, { min = null, max = null, fallback = 0 }) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  let next = parsed;
  if (min !== null) next = Math.max(min, next);
  if (max !== null) next = Math.min(max, next);
  return next;
};

const roundTo = (value, places = 0) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  const factor = 10 ** places;
  return Math.round(parsed * factor) / factor;
};

export const getLocalOpsConfig = () => {
  const feeBps = clampNumber(process.env.REACT_APP_LOCALOPS_FEE_BPS, {
    min: 0,
    max: 10000,
    fallback: 1200,
  });
  const stakeOffering = clampNumber(
    process.env.REACT_APP_LOCALOPS_STAKE_OFFERING_JGK,
    { min: 0, max: 1000000, fallback: 150 },
  );
  const stakeTask = clampNumber(
    process.env.REACT_APP_LOCALOPS_STAKE_TASK_JGK,
    { min: 0, max: 1000000, fallback: 100 },
  );
  const stakeAssist = clampNumber(
    process.env.REACT_APP_LOCALOPS_STAKE_ASSIST_JGK,
    { min: 0, max: 1000000, fallback: 200 },
  );
  const jgkPerUsd = clampNumber(process.env.REACT_APP_JGK_PER_USD, {
    min: 1,
    max: 1000000,
    fallback: 1000,
  });

  return {
    feeBps,
    feePercent: feeBps / 100,
    stakeOffering,
    stakeTask,
    stakeAssist,
    jgkPerUsd,
  };
};

export const formatJGK = (value) => {
  const amount = roundTo(value, 0);
  return `${amount} JGK`;
};

export const formatUsdJgkPairFromJgk = (value, rate) => {
  const amount = roundTo(value, 0);
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const safeRate = Number.isFinite(rate) && rate > 0 ? rate : 1000;
  const usd = safeAmount / safeRate;
  return `$${usd.toFixed(2)} (${safeAmount.toLocaleString('en-US')} JGK)`;
};

export const formatPercent = (percent) => {
  const rounded = roundTo(percent, 1);
  return `${rounded}%`;
};

export const getStakeForType = (type, config) => {
  if (!config) return 0;
  if (type === 'assisted_transport' || type === 'assistance') {
    return config.stakeAssist;
  }
  if (type === 'offering_service' || type === 'offering_product') {
    return config.stakeOffering;
  }
  if (type === 'offering') return config.stakeOffering;
  return config.stakeTask;
};

export const buildTaskPayoutDisplay = (task, config) => {
  if (!task || !config) return null;
  const feePercent = Number.isFinite(task.platformFeePercent)
    ? task.platformFeePercent
    : config.feePercent;
  const feeRate = feePercent / 100;
  const price =
    Number.isFinite(task.price) ? task.price : Number(task.meta?.price || 0);
  if (!Number.isFinite(price) || price <= 0) return null;
  const feeUsd = roundTo(price * feeRate, 2);
  const providerUsd = roundTo(price - feeUsd, 2);
  return {
    feePercentLabel: formatPercent(feePercent),
    feeJgk: formatJGK(feeUsd * config.jgkPerUsd),
    providerJgk: formatJGK(providerUsd * config.jgkPerUsd),
  };
};
